import { useMutation } from 'react-query';

import { useVpSnackbar } from '../vp-ui';
import api from '../utils/api';
import { DOWNLOAD } from '../constants/endpoints';

// apis
const postDownloadData = ({ data }) => api.post(DOWNLOAD, data);

// mutations
export const usePostDownloadData = () => {
  const { addSnackbarError, addSnackbarSuccess } = useVpSnackbar();

  return useMutation(postDownloadData, {
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || '';

      addSnackbarError({
        message: `Error attempting to download selected videos. ${errorMessage}`
      });
    },
    onSuccess: () => {
      addSnackbarSuccess({
        message: `Your download is In Progress! We'll email you as soon as it's done!`
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/useDownloadData.js